/* eslint-disable no-undef */

const ENV = window.statsig_environment;

export const logError = (errorTitle, error, environment = ENV) => {
  if (environment === 'development') {
    console.error(errorTitle, error);
  }

  if (typeof Bugsnag !== 'function') {
    return;
  }

  Bugsnag.notify(errorTitle, error);
};
